import { render, staticRenderFns } from "./privacy_policy.vue?vue&type=template&id=72c16cea&scoped=true&"
import script from "./privacy_policy.vue?vue&type=script&lang=js&"
export * from "./privacy_policy.vue?vue&type=script&lang=js&"
import style0 from "./privacy_policy.vue?vue&type=style&index=0&id=72c16cea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c16cea",
  null
  
)

export default component.exports